var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled from "styled-components";
import { Grid } from "../../components";
import { COLOR } from "../../theme/constants";
export var InfoBox = styled(Grid.Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0 auto 5.625rem auto;\n  max-width: 650px;\n  width: 100%;\n  border-radius: 10px;\n  padding: 0.75rem;\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  p {\n    width: 100%;\n\n    a {\n      display: block;\n      color: ", ";\n      text-decoration: underline;\n    }\n  }\n"], ["\n  margin: 0 auto 5.625rem auto;\n  max-width: 650px;\n  width: 100%;\n  border-radius: 10px;\n  padding: 0.75rem;\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  p {\n    width: 100%;\n\n    a {\n      display: block;\n      color: ", ";\n      text-decoration: underline;\n    }\n  }\n"])), COLOR.white, COLOR.brandGreen);
var templateObject_1;